export default "__VITE_ASSET__AVKFT8Um__"